/* Libraries */
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

/* Components */
import UserAvatar, {
  getUserAvatarPlaceholder,
} from '~/src/components/UserAvatar';
import Dropdown from '~/src/components/Dropdown';

/* Styles */
import dropdownStyles from '~/src/components/Dropdown/styles';
import styles from './styles';
import { useRemoteAccessDialog } from '~/src/components/RemoteAccessDialog';
import { useCurrentOrg, useLogout } from '~/src/entities/user';
import { useAreUIFlagsEnabled, useUIFlagsModal } from '~/src/entities/uiFlags';

const UserAvatarDropdownMenu = ({
  email,
  avatar,
  initials,
  organization,
  showSwitchOrganizationsAction,
  showEditProfileAction,
  onEditProfile,
  onSwitchOrganizations,
}) => {
  const { org } = useCurrentOrg();
  const isInternalUser = org?.enable_dev_tools;
  const areUIFlagsEnabled = useAreUIFlagsEnabled();
  const src = avatar || getUserAvatarPlaceholder(initials);
  const { mutate: onLogout } = useLogout();

  const [showRemoteAccessDialog, remoteAccessDialog] = useRemoteAccessDialog();
  const [showUIFlagsManager, uiFlagsManagerDialog] = useUIFlagsModal();

  const renderTrigger = ({ toggleDropdown }) => (
    <UserAvatar
      onClick={toggleDropdown}
      src={src}
      triangleOrientation={'down'}
      showTriangle={true}
    />
  );

  return (
    <>
      <Dropdown renderTrigger={renderTrigger} width={200}>
        <div className={css(styles.headerDropdown)}>
          <div className={css(styles.headerDropdownOrganizationLabel)}>
            {organization}
          </div>
          <div className={css(styles.headerDropdownOrganizationEmail)}>
            {email}
          </div>
        </div>
        {showSwitchOrganizationsAction && (
          <a
            className={css(dropdownStyles.dropdownActionItem)}
            onClick={onSwitchOrganizations}
          >
            Switch Organizations
          </a>
        )}
        {showEditProfileAction && (
          <a
            className={css(dropdownStyles.dropdownActionItem)}
            onClick={onEditProfile}
          >
            Edit profile
          </a>
        )}
        {isInternalUser ? (
          <>
            <a
              className={css(dropdownStyles.dropdownActionItem)}
              onClick={showRemoteAccessDialog}
            >
              Remote Access
            </a>
            <a
              href="/internaltools"
              className={css(dropdownStyles.dropdownActionItem)}
              data-testid="nav-admin-panel-link"
            >
              Admin Panel
            </a>
          </>
        ) : null}
        {areUIFlagsEnabled ? (
          <a
            className={css(dropdownStyles.dropdownActionItem)}
            onClick={showUIFlagsManager}
          >
            Manage UI Flags
          </a>
        ) : null}
        <a
          className={css(dropdownStyles.dropdownActionItem)}
          onClick={onLogout}
        >
          Logout
        </a>
      </Dropdown>
      {remoteAccessDialog}
      {uiFlagsManagerDialog}
    </>
  );
};

UserAvatarDropdownMenu.propTypes = {
  showEditProfileAction: PropTypes.bool,
  showSwitchOrganizationsAction: PropTypes.bool,
  organization: PropTypes.string,
  email: PropTypes.string,

  onEditProfile: PropTypes.func,
  onSwitchOrganizations: PropTypes.func,
};

UserAvatarDropdownMenu.defaultProps = {
  showEditProfileAction: false,
  showSwitchOrganizationsAction: false,

  onEditProfile: () => {},
  onSwitchOrganizations: () => {},
};

export default UserAvatarDropdownMenu;
